import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class NomadeInterceptorService implements HttpInterceptor {

	isNomade: boolean = false

	constructor() {
		const nomade = localStorage.getItem('ATYL_MODE_NOMADE')
		if (nomade == 'true') {
			this.isNomade = true
		}
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		//console.log('intercepted request ... ', this.isNomade)
		return next.handle(req)
	}
}
